import React, { createContext, useEffect } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const { loading, user, isAuth, handleLogin, handleLogout, socket } = useAuth();

  useEffect(() => {
    const companyId = isAuth && user?.companyId ? Number(user.companyId) : null;
    window.__venturaCompanyId = companyId;
    window.dispatchEvent(new CustomEvent("ventura:companyChanged", { detail: { companyId } }));
  }, [isAuth, user?.companyId]);

	return (
		<AuthContext.Provider
			value={{ loading, user, isAuth, handleLogin, handleLogout, socket }}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };